export default __webpack_public_path__ + "static/media/pgmico(19).abb102e7.png";